import * as React from 'react';
import { Text, Modal, MessageBoxFunctionalLayout, TextButton } from 'wix-style-react';
import { translate, InjectedTranslateProps } from 'react-i18next';
import { DataHooks } from '@src/constants/data-hooks';
import { withBIModalEvents, ModalProps } from '@src/components/with-bi-modal-events/with-bi-modal-events';
import { PopupType } from '@src/context/actions/bi';

type Props = ModalProps & InjectedTranslateProps & { isOpen: boolean; learnMoreKBLink: string };
const MissingLinkPromptComponent = translate()(({ t, isOpen, onClose, onCancel, onOk, learnMoreKBLink }: Props) => (
  <Modal dataHook={DataHooks.SaveMissingLinkModal} isOpen={isOpen} onRequestClose={onClose} shouldCloseOnOverlayClick>
    <MessageBoxFunctionalLayout
      dataHook={DataHooks.SaveMissingLinkPrompt}
      confirmText={t('privacy-policy.missing-link-prompt.cancel')}
      onOk={onCancel}
      cancelText={t('privacy-policy.missing-link-prompt.save')}
      onCancel={onOk}
      onClose={onClose}
      title={t('privacy-policy.missing-link-prompt.title')}
      width="600px"
    >
      <Text>
        {t('privacy-policy.missing-link-prompt.message')}{' '}
        <TextButton onClick={() => window.open(learnMoreKBLink, '_blank')}>
          {t('privacy-policy.missing-link-prompt.learn-more')}
        </TextButton>
      </Text>
    </MessageBoxFunctionalLayout>
  </Modal>
));

export const MissingLinkPrompt = withBIModalEvents(PopupType.MissingPolicy)(MissingLinkPromptComponent);
